import { ChangeDetectionStrategy, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { IBatchError } from './mes-batch-service';

interface ErrorMessage {
	params: object;
}

enum BatchErrorType {
	Undefined = 0,
	Sql = 1,
	Worker = 2,
	NotFound = 3,
	UncaughtException = 4,
}

@Component({
	selector: 'app-batch-status',
	templateUrl: './batch-status.component.html',
	styleUrls: ['./batch-status.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class BatchStatusComponent {
	public showPopup: boolean;
	public errorMessages: ErrorMessage[];

	private _errors: IBatchError[] = [];

	@Input()
	set errors(value: IBatchError[] | null | undefined) {
		this._errors = value ?? [];
		this.setErrorMessages();
	}

	get errors(): IBatchError[] {
		return this._errors;
	}

	@ViewChild('popup') popup: ElementRef<HTMLDivElement>;

	private setErrorMessages(): void {
		this.errorMessages = this._errors.map((err) => ({
			params: {
				...err,
				type: this.normalizeErrorType(err.type),
			},
		}));
	}

	private normalizeErrorType(type: unknown): string {
		const numeric = Number(type);

		if (!Number.isNaN(numeric) && BatchErrorType[numeric] !== undefined) {
			return BatchErrorType[numeric];
		}

		return String(type);
	}

	public get hasAnyErrors(): boolean {
		return this._errors.length > 0;
	}

	public pointerEnter(): void {
		this.showPopup = true;
	}

	public pointerMove(event: PointerEvent): void {
		this.updatePopupPosition(event);
	}

	public pointerOut(): void {
		this.showPopup = false;
	}

	private updatePopupPosition(event: PointerEvent): void {
		if (this.popup && this.popup.nativeElement) {
			const bounds = this.popup.nativeElement.getBoundingClientRect();
			this.popup.nativeElement.style.left = `${event.clientX - bounds.width}px`;
			this.popup.nativeElement.style.top = `${event.clientY + 24}px`;
		}
	}

	public getErrorString(params: Record<string, any>): string {
		const { alias, name, type, message } = params;

		if (alias && name && type && message) {
			return `(${alias}) ${name} | ${type} | ${message}`;
		}

		if (type && message) {
			return `${type} | ${message}`;
		}

		return Object.values(params).join(' | ');
	}
}
